import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import './fastlink.css';
// href="http://localhost:3000/catalog/wall_split_system?PRICE[from]=0&PRICE[to]=20000&Технология[]=Инверторная&Цвет[]=Чёрный&Обогрев[]=до%20-15С°"
function FastLinkBar() {

//  encodeURI применяется к всему URL, чтобы сохранить /, ?, & и т.д.

//  encodeURIComponent используется для значений параметров — чтобы закодировать Чёрный, -15С° и т.п.

// href={`/catalog/wall_split_system?${encodeURI('Цвет[]')}=${encodeURIComponent('Чёрный')}&${encodeURI('Технология[]')}=${encodeURIComponent('Инверторная')}`}
  return (
    <div className="py-4 fastlink">
        <Container className="mb-2">
        <span>Часто ищут:</span>
        </Container>
    <Container className="d-flex align-items-center flex-wrap">
      
      <Button
        href={`/catalog/wall_split_system?${encodeURIComponent('Цена')}[to]=20000&${encodeURIComponent('Цена')}[from]=1`}  variant="dark"  className="rounded-4 align-items-center me-2 mb-2">
        Сплит-системы до 20.000₽    </Button>
      <Button
        href={`/catalog/wall_split_system?${encodeURIComponent('Тип компрессора')}=${encodeURIComponent('Да')}`} variant="dark" className="rounded-4 align-items-center me-2 mb-2" >
        Инверторная технология      </Button>    
      <Button
            href={`/catalog/wall_split_system?${encodeURIComponent('Бесплатный монтаж')}=${encodeURIComponent('1')}`}
            variant="dark" className="rounded-4 align-items-center me-2 mb-2">
            Бесплатный монтаж*          </Button>
      <Button
        href={`/catalog/wall_split_system?${encodeURIComponent('Цвет')}=${encodeURIComponent('Черный')}`} 
        variant="dark" className="rounded-4 align-items-center me-2 mb-2" >
        Сплит-система чёрного цвета      </Button>   
        <Button href="/catalog/cassette_split" variant="dark" className="rounded-4 align-items-center me-2 mb-2">Кондиционер кассетного типа</Button>     
      <Button
        href={`/catalog/wall_split_system?${encodeURIComponent('Площадь помещения')}[to]=21&${encodeURIComponent('Площадь помещения')}[from]=1`} variant="dark" className="rounded-4 align-items-center me-2 mb-2" >
        Сплит-системы на площадь до 21м<sup>2</sup>      </Button>        
      <Button
        href={`/catalog/wall_split_system?${encodeURIComponent('Обогрев зимой')}=-25`} 
        variant="dark" className="rounded-4 align-items-center me-2 mb-2" >
        Работа на обогрев до -25С°      </Button>
      <Button href="#" variant="dark" className="rounded-4 align-items-center me-2 mb-2">Зимний комплект</Button>
    </Container>
    </div>
  );
}

export default FastLinkBar;